import { Search, ArrowRight, Zap, BarChart3, FileText, Briefcase } from "lucide-react";
import { AnalysisPreview } from "./AnalysisPreview";

const BENEFITS = [
  { icon: Zap, label: "Instant Analysis" },
  { icon: BarChart3, label: "Cash Flow • Cap Rate • ROI" },
  { icon: FileText, label: "Detailed Reports" },
  { icon: Briefcase, label: "Built for Investors" },
];

export function HeroSection({ searchQuery, setSearchQuery, onSearch, topDeal, dealsLoading, onOpenDeal }) {
  return (
    <section className="bg-rd-navy rd-grain text-white" data-testid="hero-section">
      <div className="rd-container relative grid lg:grid-cols-[1.25fr_1fr] gap-12 lg:gap-10 items-center pt-14 pb-16 lg:pt-24 lg:pb-28">
        <div className="max-w-2xl min-w-0">
          <p className="rd-eyebrow text-rd-action mb-5">Real Estate Investment Analysis</p>
          <h1 className="rd-h1 text-[40px] sm:text-5xl lg:text-6xl" data-testid="hero-h1">
            Know if a Rental Property <span className="text-rd-action">Makes Money in 10 Seconds.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-white/85 leading-relaxed max-w-xl">
            Search any property and instantly see cash flow, cap rate, ROI, and the RealixData Deal Score — so you can make investment decisions with better data.
          </p>

          <form onSubmit={onSearch} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-[640px]" data-testid="hero-search" role="search">
            <label htmlFor="hero-search-input" className="sr-only">Property address, city or ZIP code</label>
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-rd-muted pointer-events-none" aria-hidden="true" />
              <input
                id="hero-search-input"
                type="text"
                placeholder="Enter a property address, city or ZIP code..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="rd-input"
                autoComplete="off"
                data-testid="hero-search-input"
              />
            </div>
            <button type="submit" className="rd-btn rd-btn-primary h-[52px] px-6" data-testid="hero-search-btn">
              Analyze Property <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </button>
          </form>

          <ul className="mt-7 grid grid-cols-2 gap-x-6 gap-y-3 text-sm font-medium text-white/85 max-w-[640px]" aria-label="Key benefits">
            {BENEFITS.map(({ icon: Icon, label }) => (
              <li key={label} className="inline-flex items-center gap-2">
                <Icon className="w-4 h-4 text-white/60 flex-shrink-0" aria-hidden="true" /> {label}
              </li>
            ))}
          </ul>
        </div>

        <div className="w-full min-w-0 max-w-[560px] lg:max-w-none mx-auto">
          <AnalysisPreview deal={topDeal} loading={dealsLoading} onOpen={onOpenDeal} />
        </div>
      </div>
    </section>
  );
}
